module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Service")]), _vm._v(" "), _c('h3', [_vm._v(" University Service ")]), _vm._v(" "), _c('table', [_c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "40%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "50%"
    }
  }), _vm._v(" "), _c('tbody', _vm._l((_vm.servicelist.filter(function (x) { return x['type'] == 'university'; })), function(sv) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(sv.years))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sv.role))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sv.entity)), (sv.subentity) ? _c('span', [_vm._v(", " + _vm._s(sv.subentity))]) : _vm._e()])])
  }))]), _vm._v(" "), _c('h3', [_vm._v(" Disciplinary Service ")]), _vm._v(" "), _c('table', [_c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "80%"
    }
  }), _vm._v(" "), _c('tbody', _vm._l((_vm.servicelist.filter(function (x) { return x['type'] == 'disciplinary'; })), function(sv) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(sv.years))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sv.role))])])
  }))]), _vm._v(" "), _c('h3', [_vm._v(" Community Service and Outreach")]), _vm._v(" "), _c('table', [_c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "80%"
    }
  }), _vm._v(" "), _c('tbody', _vm._l((_vm.servicelist.filter(function (x) { return x['type'] == 'community'; })), function(sv) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(sv.years))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sv.role))])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53dcc110","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cv/service.vue
// module id = 194
// module chunks = 0